// src/services/jewelleryPlan/quoteService.js

import api from "../api";
import { JEWELLERY_API_ENDPOINTS } from "../../constants/jewellery.constant";

const replacePathParams = (path, params) => {
  let result = path;
  Object.keys(params).forEach((key) => {
    result = result.replace(`:${key}`, params[key]);
  });
  return result;
};

const quoteService = {
  /**
   * Check balance and purchasing power
   * @param {string} planId - Plan ID
   * @param {number} karat - Gold karat (22, 18, 14, etc.)
   * @returns {Promise} Balance data
   */
  checkBalance: async (planId, karat = 22) => {
    const url = replacePathParams(JEWELLERY_API_ENDPOINTS.CHECK_BALANCE, {
      planId,
    });
    const response = await api.get(url, { params: { karat } });
    return response.data;
  },

  /**
   * Create balance quote (locks value for redemption)
   * @param {object} data - Quote data
   * @returns {Promise} Created quote
   */
  createBalanceQuote: async (data) => {
    const response = await api.post(
      JEWELLERY_API_ENDPOINTS.CREATE_BALANCE_QUOTE,
      data
    );
    return response.data;
  },

  /**
   * Get quote by ID
   * @param {string} quoteId - Quote ID
   * @returns {Promise} Quote data
   */
  getQuote: async (quoteId) => {
    const url = replacePathParams(JEWELLERY_API_ENDPOINTS.GET_QUOTE, {
      id: quoteId,
    });
    const response = await api.get(url);
    return response.data;
  },

  /**
   * Validate quote (check if expired/used)
   * @param {string} quoteId - Quote ID
   * @returns {Promise} Validation result
   */
  validateQuote: async (quoteId) => {
    const url = replacePathParams(JEWELLERY_API_ENDPOINTS.VALIDATE_QUOTE, {
      id: quoteId,
    });
    const response = await api.get(url);
    return response.data;
  },

  /**
   * Get all quotes for a plan
   * @param {string} planId - Plan ID
   * @param {object} params - Query params (page, limit)
   * @returns {Promise} List of quotes
   */
  getPlanQuotes: async (planId, params = {}) => {
    const url = replacePathParams(JEWELLERY_API_ENDPOINTS.GET_PLAN_QUOTES, {
      planId,
    });
    const response = await api.get(url, { params });
    return response.data;
  },
};

export default quoteService;
